.footerWithTimerContainer {
  position: sticky;
  bottom: 0;
  z-index: 5;
  background: rgba(251, 252, 255, 0.96);
  border-top: 1px solid var(--color-border);
  backdrop-filter: blur(12px);
}

.footerWithTimerContent {
  max-width: var(--page-max-width);
  min-height: 4rem;
  margin: 0 auto;
  padding-inline: var(--header-footer-padding-x);

  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
}

.footerTimer {
  justify-self: center;
  text-align: center;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
}

.snoozeButton {
  background-color: #084b8a;
  color: white;
  border-radius: 5px;
  padding: 5px 10px;
  transition: background-color 0.3s ease;
}

.snoozeButton:hover {
  background-color: #063f6c;
}

.recommendationsButton {
  background-color: #28a745;
  color: white;
  border-radius: 5px;
  padding: 5px 10px;
  transition: background-color 0.3s ease;
}

.recommendationsButton:hover {
  background-color: #218838;
}

.backButton {
  composes: footerButton from "../../styles/components.module.css";
  background: var(--color-surface);
  color: var(--color-primary);
  justify-self: start;
}

.nextButton {
  composes: footerButton from "../../styles/components.module.css";
  justify-self: end;
  min-width: 15rem;
  border-color: transparent;
  background: var(--color-primary);
  color: var(--color-primary-text);
}